import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewRef} from "@angular/core";
import {BackgroundTask} from "../../store/application-state";
import {Store} from '@ngrx/store';
import {TaskCancel} from '../../store/actions';

@Component({
  standalone: false,
  selector: "wfm-task-progress",
  templateUrl: "./task-progress.component.html",
  styleUrls: ["./task-progress.component.scss"]
})
export class TaskProgressComponent implements OnInit {
  @Input() task:BackgroundTask
  @Input() canCancel:Boolean=false;
  @Output() cancelTask: EventEmitter<any> = new EventEmitter<any>();
  /**
   * Gates the visually-hidden aria-live status message. It stays false for the
   * first render so the live region mounts empty, then flips true so assistive
   * technologies announce that processing has started ("Loading, please wait.").
   */
  announceLoading = false;
  constructor(private cd: ChangeDetectorRef) {

  }

  ngOnInit(): void {
    setTimeout(() => {
      this.announceLoading = true;
      if (!(this.cd as ViewRef).destroyed) {
        this.cd.detectChanges();
      }
    });
  }
  onCancelTask(){
    this.cancelTask.emit();
  }
}
